// BSC Mainnet
export const NETWORK_NAME_BSC_MAINNET = "Binance Smart Chain (BSC)";
export const NETWORK_CHAIN_ID_BSC_MAINNET = 56;
export const ORIGIN_PRISONER_CONTRACT_ADDRESS_BSC_MAINNET = "0x1e4712A93beEc0aa26151CF44061eE91DD56f921";
export const ORIGIN_LEADERBOARD_CONTRACT_ADDRESS_BSC_MAINNET = "0x96E6AF6E9e400d0Cd6a4045F122df22BCaAAca59";

// BSC Testnet
export const NETWORK_NAME_BSC_TESTNET = "Binance Smart Chain Testnet";
export const NETWORK_CHAIN_ID_BSC_TESTNET = 97;
export const ORIGIN_PRISONER_CONTRACT_ADDRESS_BSC_TESTNET = "0xc254cDd94b834966DB91e99bb6aE073Df3F55Bd7";
export const ORIGIN_LEADERBOARD_CONTRACT_ADDRESS_BSC_TESTNET = "0xFB22c49674E4482C22D4499392a8e2f760D84f8d";

// Depending on environment
export const NETWORK_NAME = process.env.NODE_ENV === "production" ? NETWORK_NAME_BSC_MAINNET : NETWORK_NAME_BSC_TESTNET;
export const NETWORK_CHAIN_ID = process.env.NODE_ENV === "production" ? NETWORK_CHAIN_ID_BSC_MAINNET : NETWORK_CHAIN_ID_BSC_TESTNET;
export const ORIGIN_PRISONER_CONTRACT_ADDRESS = process.env.NODE_ENV === "production" ? ORIGIN_PRISONER_CONTRACT_ADDRESS_BSC_MAINNET : ORIGIN_PRISONER_CONTRACT_ADDRESS_BSC_TESTNET;
export const ORIGIN_LEADERBOARD_CONTRACT_ADDRESS = process.env.NODE_ENV === "production" ? ORIGIN_LEADERBOARD_CONTRACT_ADDRESS_BSC_MAINNET : ORIGIN_LEADERBOARD_CONTRACT_ADDRESS_BSC_TESTNET;

// Common
export const GAME_VERSION = 1;
export const EMAIL = "cryptospaceprison@gmail.com";
export const TWITTER_LINK = "https://twitter.com/csp_fun";
export const DISCORD_LINK = "https://discord.gg/B4N9UHZ9d3";
export const EMAIL_LINK = "mailto:" + EMAIL;

// Dashboard
export const IS_VOTING_SPACE_ENABLED = false;